// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "js/components.js";
	if (chunkId === 957) return "js/routes.js";
	if (chunkId === 863) return "js/components-editor.js";
	// return url for filenames based on template
	return undefined;
};